export const styles = {
  wrapper: {
    padding: '20px 35px',
    color: '#011533',
    fontFamily: "'Proxima Nova', sans-serif",
  },
  title: {
    fontWeight: 800,
    fontSize: '32px',
  },
  text: {
    fontSize: '16px',
    color: '#979797',
    '& span': {
      color: '#011533',
    },
  },
  container: {},
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 0 20px',
    justifyContent: 'space-between',
    '& > div:first-child': {
      display: 'flex',
      alignItems: 'center',
      '& > div:first-child': {
        marginRight: '20px',
      },
    },
  },
  tableContainer: {
    maxHeight: '400px',
  },

  root: {
    width: '100%',
    '& > div': {
      marginBottom: '30px',
    },
  },
  paper: {
    width: '100%',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}
